import React, { useEffect, useState } from "react"
import {
  Col,
  Card,
  Nav,
  CardBody,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Table,
} from "reactstrap"
import classnames from "classnames"

//Simple bar
import SimpleBar from "simplebar-react"
import MainService from "../../../../Services/MainService"
import NoData from "../../../../components/NoData/NoData"



const QuickView = ({ data, isInstantPaymentPage = false, transactionDetails }) => {

  const [activeTab, setactiveTab] = useState("1");

  useEffect(() => {
    if (transactionDetails?.instantPayment || transactionDetails?.paymentCustomerDetails) {
      setactiveTab("1");
    } else if (data?.agentOverview) {
      setactiveTab("2");
    }
  }, [data, transactionDetails]);

  const returnPayingCustomerName = (payingCustomerData) => {
    if (!payingCustomerData) return "";
    const { customerFullName = "", firstname = "", lastname = "" } = payingCustomerData;
    return customerFullName || `${firstname} ${lastname}`;
  };

  const returnPayingCustomerEmail = (payingCustomerData) => {
    if (!payingCustomerData) return "";
    const { customerEmail = "", email = "" } = payingCustomerData;
    return customerEmail || email;
  };

  return (
    <Card className="quick-view">
      <CardBody>
        <Nav pills className="bg-light rounded flex-nowrap text-center gap-1" role="tablist">
          {
            transactionDetails && (transactionDetails?.instantPayment || transactionDetails.paymentCustomerDetails) ?
              <NavItem className="rounded w-100">
                <NavLink
                  className={`h-100 ${classnames({ active: activeTab === "1" })}`}
                  onClick={() => {
                    setactiveTab("1")
                  }}
                >
                  Paying Customer
                </NavLink>
              </NavItem>
              : null
          }

          <NavItem className="rounded w-100">
            <NavLink
              className={`h-100 ${classnames({ active: activeTab === "2" })}`}
              onClick={() => {
                setactiveTab("2")
              }}
            >
              Responsible Agent
            </NavLink>
          </NavItem>
          {
            isInstantPaymentPage ? null :
              <NavItem className="rounded w-100">
                <NavLink
                  className={`h-100 ${classnames({ active: activeTab === "3" })}`}
                  onClick={() => {
                    setactiveTab("3")
                  }}
                >
                  Merchant
                </NavLink>
              </NavItem>
          }
        </Nav>
        <TabContent activeTab={activeTab} className="mt-4">
          {
            transactionDetails && (transactionDetails.paymentCustomerDetails || transactionDetails.instantPayment) ?
              <TabPane tabId="1">
                <SimpleBar style={{ maxHeight: "330px" }}>
                  <div className="table-responsive">
                    <Table className="table align-middle table-nowrap">
                      <tbody>
                        {/* <tr>
                      <td><h5 className="font-size-12 mb-1">Paying Customer ID:</h5></td>
                      <td><h5 className="font-size-12 mb-0 ">{data.payignCustomerOverview?.uniqueId || "Not set"}</h5></td>
                    </tr> */}
                        <tr>
                          <td><h5 className="font-size-12 mb-1">Name:</h5></td>
                          <td><h5 className="font-size-12 mb-0 ">
                            {
                              returnPayingCustomerName(transactionDetails?.instantPayment || transactionDetails?.paymentCustomerDetails)
                            }
                          </h5></td>
                        </tr>
                        <tr>
                          <td><h5 className="font-size-12 mb-1">Email:</h5></td>
                          <td><h5 className="font-size-12 mb-0 ">
                            {
                              returnPayingCustomerEmail(transactionDetails?.instantPayment || transactionDetails?.paymentCustomerDetails)
                            }
                          </h5></td>
                        </tr>
                        {
                          transactionDetails.paymentCustomerDetails?.phoneNumber ?
                            <tr>
                              <td><h5 className="font-size-12 mb-1">Telephone Number:</h5></td>
                              <td><h5 className="font-size-12 mb-0 ">{transactionDetails.paymentCustomerDetails?.phoneNumber ? MainService.formatPhoneNumber(transactionDetails.paymentCustomerDetails?.phoneNumber) : "Not set"}</h5></td>
                            </tr>
                            : null
                        }
                        {/* <tr>
                              <td><h5 className="font-size-12 mb-1">Address:</h5></td>
                              <td><h5 className="font-size-12 mb-0 ">{payignCustomer?.address || "Not set"}</h5></td>
                            </tr> */}
                        {/* <tr>
                          <td><h5 className="font-size-12 mb-1">Wallet Address:</h5></td>
                          <td><h5 className="font-size-12 mb-0 ">{data.payignCustomerOverview?.walletAddress || "Not set"}</h5></td>
                        </tr> */}
                      </tbody>
                    </Table>
                  </div>
                </SimpleBar>
              </TabPane>
              : null
          }

          {
            data ?
              <>
                <TabPane tabId="2">
                  <SimpleBar style={{ maxHeight: "330px" }}>
                    <div className="table-responsive">
                      <Table className="table align-middle table-nowrap">
                        <tbody>
                          {/* <tr>
                              <td><h5 className="font-size-12 mb-1">Liveness Test Status:</h5></td>
                              <td>
                                <h5 className="font-size-12 mb-0 ">
                                  <span className={`badge badge-soft-${data.agentOverview?.livenessTestStatus ? "success" : "danger"} font-size-14 badge badge-pill`}>
                                    {data.agentOverview?.livenessTestStatus ? "Verified" : "Not verified"}
                                  </span>
                                </h5>
                              </td>
                            </tr> */}
                          {/* <tr>
                              <td><h5 className="font-size-12 mb-1">Bank Account:</h5></td>
                              <td><h5 className="font-size-12 mb-0 ">{data.agentOverview?.bankAccount || "Not set"}</h5></td>
                            </tr>
                            <tr>
                              <td><h5 className="font-size-12 mb-1">Business Registered Address:</h5></td>
                              <td><h5 className="font-size-12 mb-0 ">{data.agentOverview?.businessRegisteredAddress || "Not set"}</h5></td>
                            </tr>
                            <tr>
                              <td><h5 className="font-size-12 mb-1">KYC Level:</h5></td>
                              <td><h5 className="font-size-12 mb-0 ">{data.agentOverview?.kycLevel || "Not set"}</h5></td>
                            </tr>
                            <tr>
                              <td><h5 className="font-size-12 mb-1">Fiat Off-Ramp Interval:</h5></td>
                              <td><h5 className="font-size-12 mb-0 ">{data.agentOverview?.fiatOffRampInterval || "Not set"}</h5></td>
                            </tr>
                            <tr>
                              <td><h5 className="font-size-12 mb-1">Cutoff Time:</h5></td>
                              <td><h5 className="font-size-12 mb-0 ">{data.agentOverview?.cutoffTime ? moment(MainService.convertUTCDateToLocalDate(new Date(data.agentOverview?.cutoffTime))).format("LL HH:mm") : "Not set"}</h5></td>
                            </tr> */}

                          {/* <tr>
                          <td><h5 className="font-size-12 mb-1">Agent ID:</h5></td>
                          <td><h5 className="font-size-12 mb-0 ">{data.agentOverview?.uniqueId || "Not set"}</h5></td>
                        </tr> */}
                          <tr>
                            <td><h5 className="font-size-12 mb-1">Name:</h5></td>
                            <td><h5 className="font-size-12 mb-0 ">{data.agentOverview?.legalBusinessName || "Not set"}</h5></td>
                          </tr>
                          <tr>
                            <td><h5 className="font-size-12 mb-1">Telephone Number:</h5></td>
                            <td><h5 className="font-size-12 mb-0 ">{data.agentOverview?.phoneNumber ? MainService.formatPhoneNumber(data.agentOverview?.phoneNumber) : "Not set"}</h5></td>
                          </tr>
                          <tr>
                            <td><h5 className="font-size-12 mb-1">Email:</h5></td>
                            <td><h5 className="font-size-12 mb-0 ">{data.agentOverview?.email || "Not set"}</h5></td>
                          </tr>
                          <tr>
                            <td><h5 className="font-size-12 mb-1">Country:</h5></td>
                            <td><h5 className="font-size-12 mb-0 ">{data.agentOverview?.country || "Not set"}</h5></td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </SimpleBar>
                </TabPane>

                <TabPane tabId="3">
                  <SimpleBar style={{ maxHeight: "330px" }}>

                    <div className="table-responsive">
                      <Table className="table align-middle table-nowrap">
                        <tbody>
                          {/* <tr>
                              <td><h5 className="font-size-12 mb-1">Legal Business Name:</h5></td>
                              <td><h5 className="font-size-12 mb-0 ">{data.merchantOverview?.legalBusinessName || "Not set"}</h5></td>
                            </tr>
                            <tr>
                              <td><h5 className="font-size-12 mb-1">Telephone Number:</h5></td>
                              <td><h5 className="font-size-12 mb-0 ">{data.merchantOverview?.phoneNumber ? MainService.formatPhoneNumber(data.merchantOverview?.phoneNumber) : "Not set"}</h5></td>
                            </tr>
                            <tr>
                              <td><h5 className="font-size-12 mb-1">Liveness Test Status:</h5></td>
                              <td>
                                <h5 className="font-size-12 mb-0 ">
                                  <span className={`badge badge-soft-${data.merchantOverview?.livenessTestStatus ? "success" : "danger"} font-size-14 badge badge-pill`}>
                                    {data.merchantOverview?.livenessTestStatus ? "Verified" : "Not verified"}
                                  </span>
                                </h5>
                              </td>
                            </tr>
                            <tr>
                              <td><h5 className="font-size-12 mb-1">Bank Account:</h5></td>
                              <td><h5 className="font-size-12 mb-0 ">{data.merchantOverview?.bankAccount || "Not set"}</h5></td>
                            </tr>
                            <tr>
                              <td><h5 className="font-size-12 mb-1">Business Registered Address:</h5></td>
                              <td><h5 className="font-size-12 mb-0 ">{data.merchantOverview?.businessRegisteredAddress || "Not set"}</h5></td>
                            </tr>
                            <tr>
                              <td><h5 className="font-size-12 mb-1">KYC Level:</h5></td>
                              <td><h5 className="font-size-12 mb-0 ">{data.merchantOverview?.kycLevel || "Not set"}</h5></td>
                            </tr>
                            <tr>
                              <td><h5 className="font-size-12 mb-1">Fiat Off-Ramp Interval:</h5></td>
                              <td><h5 className="font-size-12 mb-0 ">{data.merchantOverview?.fiatOffRampInterval || "Not set"}</h5></td>
                            </tr> */}
                          {/* <tr>
                          <td><h5 className="font-size-12 mb-1">Merchant ID:</h5></td>
                          <td><h5 className="font-size-12 mb-0 ">{data.merchantOverview?.uniqueId || "Not set"}</h5></td>
                        </tr> */}
                          <tr>
                            <td><h5 className="font-size-12 mb-1">Name:</h5></td>
                            <td><h5 className="font-size-12 mb-0 ">{data.merchantOverview?.legalBusinessName || "Not set"}</h5></td>
                          </tr>
                          <tr>
                            <td><h5 className="font-size-12 mb-1">Email:</h5></td>
                            <td><h5 className="font-size-12 mb-0 ">{data.merchantOverview?.email || "Not set"}</h5></td>
                          </tr>
                          <tr>
                            <td><h5 className="font-size-12 mb-1">Telephone Number:</h5></td>
                            <td><h5 className="font-size-12 mb-0 ">{data.merchantOverview?.phoneNumber ? MainService.formatPhoneNumber(data.merchantOverview?.phoneNumber) : "Not set"}</h5></td>
                          </tr>
                          <tr>
                            <td><h5 className="font-size-12 mb-1">Country:</h5></td>
                            <td><h5 className="font-size-12 mb-0 ">{data.merchantOverview?.country || "Not set"}</h5></td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </SimpleBar>
                </TabPane>
              </>
              : null
          }

        </TabContent>
      </CardBody>
    </Card>
  )
}

export default QuickView
